import { FC } from 'react';
import { Avatar, Badge, Menu } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { styled } from '@robocorp/theme';
import { IconLogOut, IconSettingsSliders } from '@robocorp/icons/iconic';
import { useNavigate } from 'react-router-dom';

import { useLogout, useSelector, useUserName } from '~/hooks';
import { useUserOrganizationInvites } from '~/queries';

const PlaceholderAvatar = styled(Avatar)`
  overflow: hidden;
`;

export const UserMenu: FC = () => {
  const { t } = useTranslation();
  const userName = useUserName();
  const navigate = useNavigate();
  const onLogout = useLogout();
  const { data: invites } = useUserOrganizationInvites();
  const numberOfInvites = invites?.length ?? 0;

  const userPicture = useSelector((state) => state.userResources.users.current?.details.picture);

  return (
    <Menu
      trigger={
        userPicture ? (
          <Avatar
            as="button"
            src={userPicture}
            alt="User picture"
            size="medium"
            data-testid="user__menu"
          />
        ) : (
          <PlaceholderAvatar
            forwardedAs="button"
            placeholder={userName}
            size="medium"
            data-testid="user__menu"
          />
        )
      }
      width={210}
    >
      <Menu.Item
        data-testid="user__menu-settings"
        icon={IconSettingsSliders}
        onClick={() => navigate('/settings')}
        badge={numberOfInvites > 0 && <Badge label={numberOfInvites} size="small" />}
      >
        {t('settings.title')}
      </Menu.Item>
      <Menu.Item data-testid="user__menu-logout" icon={IconLogOut} onClick={onLogout}>
        {t('logout')}
      </Menu.Item>
    </Menu>
  );
};
